import { EntityType } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Buttons = {
    CREATE: (
        <FormattedMessage
            id='Buttons.CREATE'
            description='Create text on a button'
            defaultMessage='Create'
        />
    ),
    CREATE_WITH_WIZARD: (
        <FormattedMessage
            id='Buttons.CREATE_WITH_WIZARD'
            description='Create with wizard text on a button'
            defaultMessage='Create with wizard'
        />
    ),
    RUN: (
        <FormattedMessage
            id='Buttons.RUN'
            description='Run text on a button'
            defaultMessage='Run'
        />
    ),
    CANCEL: (
        <FormattedMessage
            id='Buttons.CANCEL'
            description='Cancel text on a button'
            defaultMessage='Cancel'
        />
    ),
    DISMISS: (
        <FormattedMessage
            id='Buttons.DISMISS'
            description='Dismiss text on a button'
            defaultMessage='Dismiss'
        />
    ),
    BACK: (
        <FormattedMessage
            id='Buttons.BACK'
            description='Back text on a button'
            defaultMessage='Back'
        />
    ),
    DISCARD: (
        <FormattedMessage
            id='Buttons.DISCARD'
            description='Discard text on a button'
            defaultMessage='Discard'
        />
    ),
    SAVE_AS_DRAFT: (
        <FormattedMessage
            id='Buttons.SAVE_AS_DRAFT'
            description='Save as draft text on a button'
            defaultMessage='Save as draft'
        />
    ),
    HOME: (
        <FormattedMessage
            id='Buttons.HOME'
            description='Home text on a button'
            defaultMessage='Home'
        />
    ),
    LOGOUT: (
        <FormattedMessage
            id='Buttons.LOGOUT'
            description='Logout text on a button'
            defaultMessage='Logout'
        />
    ),
    LOGIN: (
        <FormattedMessage
            id='Buttons.LOGIN'
            description='Login text on a button'
            defaultMessage='Login'
        />
    ),
    MOVE: (
        <FormattedMessage
            id='Buttons.MOVE'
            description='Move text on a button'
            defaultMessage='Move'
        />
    ),
    SUBMIT: (
        <FormattedMessage
            id='Buttons.SUBMIT'
            description='Submit text on a button'
            defaultMessage='Submit'
        />
    ),
    SUBMIT_AND_CREATE_NEXT: (
        <FormattedMessage
            id='Buttons.SUBMIT_AND_CREATE_NEXT'
            description='Submit and create next text on a button'
            defaultMessage='Submit and create next'
        />
    ),
    SEND: (
        <FormattedMessage
            id='Buttons.SEND'
            description='Send text on a button'
            defaultMessage='Send'
        />
    ),
    DELETE: (
        <FormattedMessage
            id='Buttons.DELETE'
            description='Delete text on a button'
            defaultMessage='Delete'
        />
    ),
    REMOVE: (
        <FormattedMessage
            id='Buttons.REMOVE'
            description='Remove text on a button'
            defaultMessage='Remove'
        />
    ),
    REFRESH: (
        <FormattedMessage
            id='Buttons.REFRESH'
            description='Refresh text on a button'
            defaultMessage='Refresh'
        />
    ),
    FILTER: (
        <FormattedMessage
            id='Buttons.FILTER'
            description='Filter text on a button'
            defaultMessage='Filter'
        />
    ),
    GENERATE: Generate,
    UPDATE: (
        <FormattedMessage
            id='Buttons.UPDATE'
            description='Update text on a button'
            defaultMessage='Update'
        />
    ),
    DOWNLOAD: (
        <FormattedMessage
            id='Buttons.DOWNLOAD'
            description='Download text on a button'
            defaultMessage='Download'
        />
    ),
    TEMPLATE: (
        <FormattedMessage
            id='Buttons.TEMPLATE'
            description='Template text on a button'
            defaultMessage='Template'
        />
    ),
    OPEN: (
        <FormattedMessage
            id='Buttons.OPEN'
            description='Open text on a button'
            defaultMessage='Open'
        />
    ),
    OPEN_ALL: (
        <FormattedMessage
            id='Buttons.OPEN_ALL'
            description='Open all text on a button'
            defaultMessage='Open all'
        />
    ),
    SHOW_ALL: (
        <FormattedMessage
            id='Buttons.SHOW_ALL'
            description='Show all text on a button'
            defaultMessage='Show all'
        />
    ),
    CLOSE: (
        <FormattedMessage
            id='Buttons.CLOSE'
            description='Close text on a button'
            defaultMessage='Close'
        />
    ),
    CHANGE_STATE: (
        <FormattedMessage
            id='Buttons.CHANGE_STATE'
            description='Change state text on a button'
            defaultMessage='Change state'
        />
    ),
    REPORT_A_PROBLEM: (
        <FormattedMessage
            id='Buttons.REPORT_A_PROBLEM'
            description='Report a problem text on a button'
            defaultMessage='Report a problem'
        />
    ),
    YES: (
        <FormattedMessage
            id='Buttons.YES'
            description='Yes text on a button'
            defaultMessage='Yes'
        />
    ),
    NO: (
        <FormattedMessage
            id='Buttons.NO'
            description='No text on a button'
            defaultMessage='No'
        />
    ),
    ADD: Add,
    ADD_STOCK: (
        <FormattedMessage
            id='Buttons.ADD_STOCK'
            description='Add stock text on a button'
            defaultMessage='Add stock'
        />
    ),
    CONFIRM: (
        <FormattedMessage
            id='Buttons.CONFIRM'
            description='Confirm text on a button'
            defaultMessage='Confirm'
        />
    ),
    CONFIRMATION: (
        <FormattedMessage
            id='Buttons.CONFIRMATION'
            description='Confirmation text on a button'
            defaultMessage='Confirmation'
        />
    ),
    IMPORT: (
        <FormattedMessage
            id='Buttons.IMPORT'
            description='Import text on a button'
            defaultMessage='Import'
        />
    ),
    EXPORT: (
        <FormattedMessage
            id='Buttons.EXPORT'
            description='Export text on a button'
            defaultMessage='Export'
        />
    ),
    EXIT_KIOSK: (
        <FormattedMessage
            id='Buttons.EXIT_KIOSK'
            description='Exit kiosk text on a button'
            defaultMessage='Exit kiosk'
        />
    ),
    UPLOAD: Upload,
    LINK: (
        <FormattedMessage
            id='Buttons.LINK'
            description='Link text on a button'
            defaultMessage='Link'
        />
    ),
    UNLINK: (
        <FormattedMessage
            id='Buttons.UNLINK'
            description='Unlink text on a button'
            defaultMessage='Unlink'
        />
    ),
    ATTACH: Attach,
    CHANGE: Change,
    NEXT: (
        <FormattedMessage
            id='Buttons.NEXT'
            description='Next text on a button'
            defaultMessage='Next'
        />
    ),
    PREVIOUS: (
        <FormattedMessage
            id='Buttons.PREVIOUS'
            description='Previous text on a button'
            defaultMessage='Previous'
        />
    ),
    VIEW: (
        <FormattedMessage
            id='Buttons.VIEW'
            description='View text on a button'
            defaultMessage='View'
        />
    ),
    DROP_OFF: (
        <FormattedMessage
            id='Buttons.DROP_OFF'
            description='Drop off text on a button'
            defaultMessage='Drop-Off'
        />
    ),
    PICK_UP: (
        <FormattedMessage
            id='Buttons.PICK_UP'
            description='Pick up text on a button'
            defaultMessage='Pick-up'
        />
    ),
    SEED: (
        <FormattedMessage
            id='Buttons.SEED'
            description='Seed text on a button'
            defaultMessage='Seed'
        />
    ),
    COPY: (
        <FormattedMessage
            id='Buttons.COPY'
            description='Copy text on a button'
            defaultMessage='Copy'
        />
    ),
    EXIT: (
        <FormattedMessage
            id='Buttons.EXIT'
            description='Exit text on a button. Keep the English word "Exit" in all locales (including nl, fr, de); do not translate.'
            defaultMessage='Exit'
        />
    ),
    FORMATTED_UNLINK: FormattedUnlink,
    CLEAR: (
        <FormattedMessage
            id='Buttons.CLEAR'
            description='Clear text on a button'
            defaultMessage='Clear'
        />
    ),
    CONTINUE: (
        <FormattedMessage
            id='Buttons.CONTINUE'
            description='Continue text on a button'
            defaultMessage='Continue'
        />
    ),
    CONTINUE_TO: continueTo,
    SEARCH: (
        <FormattedMessage
            id='Buttons.SEARCH'
            description='Search text on a button'
            defaultMessage='Search'
        />
    ),
    SCAN: (
        <FormattedMessage
            id='Buttons.SCAN'
            description='Scan text on a button'
            defaultMessage='Scan'
        />
    ),
    SCAN_BADGE: (
        <FormattedMessage
            id='Buttons.SCAN_BADGE'
            description='Scan badge text on a button'
            defaultMessage='Scan badge'
        />
    ),
    SHOW_RESULTS: (
        <FormattedMessage
            id='Buttons.SHOW_RESULTS'
            description='Show results text on a button'
            defaultMessage='Show results'
        />
    ),
    PIN: (
        <FormattedMessage
            id='Buttons.PIN'
            description='Pin text on a button'
            defaultMessage='PIN'
        />
    ),
    REPORT: (
        <FormattedMessage
            id='Buttons.REPORT'
            description='Report text on a button'
            defaultMessage='Report'
        />
    ),
    RETRY: (
        <FormattedMessage
            id='Buttons.RETRY'
            description='Retry text on a button'
            defaultMessage='Retry'
        />
    ),
    ASSIGN: Assign,
    MERGE: Merge,
    RECOVER: (
        <FormattedMessage
            id='Buttons.RECOVER'
            description='Recover text on a button'
            defaultMessage='Recover'
        />
    ),
    INCLUDE_DELETED: (
        <FormattedMessage
            id='Buttons.INCLUDE_DELETED'
            description='Include deleted text on a button'
            defaultMessage='Include deleted'
        />
    ),
    EDIT: Edit,
    CHANGE_STATUS: (
        <FormattedMessage
            id='Buttons.CHANGE_STATUS'
            description='Change status text on a button'
            defaultMessage='Change status'
        />
    ),
    GO_BACK: (
        <FormattedMessage
            id='Buttons.GO_BACK'
            description='Go back text on a button'
            defaultMessage='Go back'
        />
    ),
    VIEW_DETAILED_LIST: (
        <FormattedMessage
            id='Buttons.VIEW_DETAILED_LIST'
            description='View detailed list text on a button'
            defaultMessage='View detailed list'
        />
    ),
    ADD_TO_BASKET: (
        <FormattedMessage
            id='Buttons.ADD_TO_BASKET'
            description='Add to basket text on a button'
            defaultMessage='Add to basket'
        />
    ),
    CHECKOUT: (
        <FormattedMessage
            id='Buttons.CHECKOUT'
            description='Checkout text on a button'
            defaultMessage='Checkout'
        />
    ),
    CHOOSE_DELIVERY_LOCATION: (
        <FormattedMessage
            id='Buttons.CHOOSE_DELIVERY_LOCATION'
            description='Choose delivery location text on a button'
            defaultMessage='Choose delivery location'
        />
    )
};

function Add(text?: React.ReactNode): React.ReactNode {
    if (text)
        return (
            <FormattedMessage
                id='Buttons.ADD.Something'
                description='Add something text on a button'
                defaultMessage='Add {text}'
                values={{ text }}
            />
        );
    return (
        <FormattedMessage
            id='Buttons.ADD'
            description='Add text on a button'
            defaultMessage='Add'
        />
    );
}

function Upload(type?: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.UPLOAD'
            description='Upload text on a button'
            defaultMessage='Upload {text}'
            values={{ text: type }}
        />
    );
}

function Attach(type: EntityType): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.ATTACH'
            description='Attach text on a button'
            defaultMessage='Attach {type}'
            values={{ type }}
        />
    );
}

function Change(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.CHANGE'
            description='Change text on a button'
            defaultMessage='Change {text}'
            values={{ text }}
        />
    );
}

function FormattedUnlink(count: number, singular?: React.ReactNode, plural?: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='buttons.unlinkMessage'
            defaultMessage='Do you really want to unlink {count, plural, one {this {singular}} other {these {plural}}}?'
            values={{ count: count, singular: singular, plural: plural }}
        />
    );
}

function Assign(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.ASSIGN'
            description='Assign text on a button'
            defaultMessage='Assign {text}'
            values={{ text }}
        />
    );
}

function Merge(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.MERGE'
            description='Merge text on a button'
            defaultMessage='Merge {text}'
            values={{ text }}
        />
    );
}

function Edit(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.EDIT'
            description='Edit text on a button'
            defaultMessage='Edit {text}'
            values={{ text }}
        />
    );
}
function Generate(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.Generate'
            description='Generate text on a button'
            defaultMessage='Generate {text}'
            values={{ text }}
        />
    );
}

function continueTo(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='Buttons.CONTINUE_TO'
            description='Continue to text on a button'
            defaultMessage='Continue to {text}'
            values={{ text }}
        />
    );
}
